<template>
	<div>
		<div class="d-flex align-items-center mb-3">
			<div>
				<h1 class="page-header mb-0"><i class="fa fa-compass-drafting"></i> Vázlatok</h1>
			</div>
		</div>
		<panel title="Vázlataim">
			<Loading title="Vázlatok betöltése" v-if="!drafts"></Loading>
			<NoRecords v-else-if="drafts.length == 0" title="Nincsenek vázlataid" subtitle="Munkafolyamat létrehozás félbehagyásakor menthet új vázlatot" main_icon="fa fa-compass-drafting"></NoRecords>
			<vue-good-table v-else
					:columns="columns" 
					:rows="drafts" 
					:lineNumbers="true"
					:search-options="{ enabled: false, placeholder: 'Keresés...' }" 
					:pagination-options="{
						enabled: true, 
						position: 'bottom',
						firstLabel : 'Első Lap',
						lastLabel : 'Utolsó Lap',
						nextLabel: 'következő',
						prevLabel: 'előző',
						rowsPerPageLabel: 'Sor oldalanként',
						ofLabel: '/',
						allLabel: 'Összes',
						infoFn: (params) => `első sorszám: ${params.firstRecordOnPage}`, 
					}"
				>
					<template slot="table-row" slot-scope="props">
						<span v-if="props.column.field == 'actions'">
							<button @click="loadDraft(props.row.id)" class="btn btn-purple mx-1" title="betöltés"><i class="fa fa-compass-drafting"></i></button>
							<button @click="deleteDraft(props.row.id)" class="btn btn-danger mx-1" title="törlés"><i class="fa fa-trash"></i></button>
						</span>
						<span v-else>
							{{props.formattedRow[props.column.field]}}
						</span>
					</template>
				</vue-good-table>
        </panel>
    </div>
</template>

<script>
	import Draft from "../../apis/Draft";
	import Loading from '../../components/Loading';
	import NoRecords from '../../components/NoRecords';
	import Confirmation from '../../apis/Confirmation';

	export default {
		components: {
			Loading, NoRecords
		},
		data() {
			return {
				drafts:false,
				columns: [
					{
						label: 'Név',
						field: 'name',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Létrehozva',
						field: 'created_at',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						},
					},
					{
						label: 'Műveletek',
						field: 'actions',
						sortable: false,
						thClass: 'text-end',
						tdClass: 'text-end buttons-wide-3'
					} 
				]
			}
		},
		computed:{
			user(){
				return this.$store.state.user;
			},
		},
		created(){
			Draft.index()
			.then(response => {
				this.drafts = response.data;
			})

			window.Echo.private('App.User.' + this.user.id)
			.listen('DraftCreated', (e) => {
				this.drafts.push(e.draft);
			}).listen('DraftDeleted', (e) => {
				this.drafts.splice(this.drafts.findIndex(d => d.id == e.id),1)
			})
		},
		methods: {
			deleteDraft(id){
				Confirmation.swalDelete()
				.then(response => {
					if(response.isConfirmed === true){
						Draft.delete(id)
					}
				});
			},
			loadDraft(id){
				Draft.show(id)
				.then((response) => {
					this.$root.$emit('task-load',response.data.task_object);
				});
			}
		}
	}
</script>